import { Link } from "react-router-dom";

interface LockedFeatureProps {
  /** Human-readable name of the gated feature, e.g. "Live hours". */
  label?: string;
  /** Render the compact "Upgrade" pill (useful as a small overlay badge). */
  compact?: boolean;
  className?: string;
}

/**
 * Shown in place of a paid-only feature for Free-plan listings.
 * Links straight to the listing plans page so owners can upgrade.
 */
export default function LockedFeature({
  label = "Premium feature",
  compact = false,
  className = "",
}: LockedFeatureProps) {
  return (
    <Link
      to="/listing-plans"
      title={`${label} is available on the Business & Premium plans`}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-dashed border-accent-300 bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-900 transition-colors hover:border-accent-500 hover:bg-accent-200 focus:outline-none focus:ring-2 focus:ring-accent-300 ${className}`}
    >
      <span className="flex h-3.5 w-3.5 items-center justify-center">
        <i className="ri-lock-2-line text-[13px]" />
      </span>
      {compact ? "Upgrade" : `${label} · Upgrade`}
    </Link>
  );
}